import axios from "axios";

const actionGetMilkAnalysisReport = async ({commit}, payload) => {
  const milk_analysis = await axios.get(`${process.env.VUE_APP_URL_API}/v1/reports/milk_analysis`, {params:payload});
  commit("SET_MILK_ANALYSIS", milk_analysis.data);
}

export default {
  actionGetMilkAnalysisReport
}